<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    mounted () {
      let cmp = this;
      if (window.location.hash.length > 0) {
        setTimeout(function () {
          cmp.$scrollTo(window.location.hash, 300, {
            offset: -100
          });
        }, 1);
      }
    }
  };
</script>

<style lang="scss">
@import "@/scss/_general.scss";

#app {
  font-family: "Open Sans", sans-serif;
  background: $siteBackground;
}

* {
  box-sizing: border-box;
}
</style>